import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';

export const MuiList: Components<Theme>['MuiList'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      paddingBlock: '0',
      maxHeight: '295px',
      borderRadius: '10px',
      '& .MuiMenuItem-root': {
        padding: '2px 20px',
        height: '50px', // fixed number - set in UI kit and doesn't grow depending on the content (PE-1197)
        fontSize: '14px',
        lineHeight: 1.5,
        fontWeight: 500,
        '&.Mui-selected': {
          backgroundColor: '#F8FAFE',
          color: theme.palette.primary.main,
          '&.Mui-focusVisible': {
            backgroundColor: '#F8FAFE',
          },
          '&:hover': {
            backgroundColor: '#EEF2FD',
          },
        },
        '&.Mui-focusVisible': {
          backgroundColor: 'inherit',
        },
        '&:hover': {
          backgroundColor: '#EEF2FD',
        },
      },
    }),
  },
};
